export const PASSWORD_VALIDATOR_PATTERN =
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&].{8,}$';

export const SUPPORT_LINK = 'https://airtable.com/appxBO8pYpQMldSMV/pagoUYCJBBdTcDJgm/form';
